import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combina classes Tailwind com merge inteligente
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
